import { Link } from 'react-router-dom';

import logo from '../../assets/logo.svg';
import { Icon } from '../../common/Icon/Icon';
import { useUserContext } from '../../core/context/user.context';
import './Navigation.css';

function Navigation() {
  const { user, logout } = useUserContext();

  return (
    <header className="nav">
      <div className="wrap">
        <nav>
          <Link to="/">
            <span className="sr-only">Home page</span>
            <img className="nav__logo" src={logo} alt="SleeperCharger logo" />
          </Link>
          <ul className="nav__menu">
            {!user.token ? (
              <li style={{ marginLeft: 'auto' }}>
                <Link to="login" className="link">
                  Log in
                </Link>
              </li>
            ) : user.email ? (
              <>
                <li>
                  <Link to="user" className="link">
                    Users
                  </Link>
                </li>
                <li>
                  <Link to="booking" className="link">
                    Bookings
                  </Link>
                </li>
                <li>
                  <Link to="map" className="link">
                    Map
                  </Link>
                </li>
                <li style={{ marginLeft: 'auto' }}>
                  <Link className="link" to="profile">
                    {!user.firstname && !user.lastname ? (
                      <>
                        <Icon.User className="icon-small" />
                        Profile
                      </>
                    ) : (
                      <>
                        {user.firstname ? user.firstname.charAt(0) : null}
                        {user.lastname ? user.lastname.charAt(0) : null}
                      </>
                    )}
                  </Link>
                </li>
                <li>
                  <button type="button" className="link" onClick={logout}>
                    Log Out
                  </button>
                </li>
              </>
            ) : null}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navigation;
